import React from 'react';
import { useSearchParams } from 'react-router-dom';
import * as api from '../../api';
import { useTranslation } from 'react-i18next';

const FDFicheEntreprise = () => {

    const { i18n } = useTranslation('common');
    const [searchparams] = useSearchParams();
    const [user, setUser] = React.useState(null);

    //get user data
    React.useEffect(() => {
        api.GetAllUserData({email:searchparams.get("email")}).then((response) => {
            console.log("found user")
            console.log(response.data)
            setUser(response.data)
        }).catch((error) => {
            console.log(error);
        });
    }, [])

    // get participation
    React.useEffect(() => {
        if(!user || user.participation) return;
        api.getUserParticipations({userid : user.user._id}).then((response) => {
            const _participation = response.data.find((_participation) => _participation._id === searchparams.get("pid"));
            console.log("found participation :")
            console.log(_participation)
            _participation.data = _participation.data || {}
            setUser({...user,participation:_participation});
        }).catch((error) => {
            console.log(error);
        });
    },[user]);

    return (
        <div>
            {user && user.participation && 
                <div>
                    <br/>
                    <br/>
                    <h1 className="centered">{user.hsProfile.company}</h1>
                    <br/>
                    <p>{i18n.language === "fr" ? user.hsProfile.presentation_de_l_entreprise_en_francais_500_signes_ : user.participation.data.presentation_entreprise_anglais}</p><br/>
                    {user.hsProfile.address && <>{i18n.language === "fr" ? "Adresse postale" : "Address"} : <span className="thin">{user.hsProfile.address}</span><br/><br/></>}
                    {user.hsProfile.zip && <>{i18n.language === "fr" ? "Code postal" : "Postcode"} : <span className="thin">{user.hsProfile.zip}</span><br/><br/></>}
                    {user.hsProfile.city && <>{i18n.language === "fr" ? "Ville" : "City"} : <span className="thin">{user.hsProfile.city}</span><br/><br/></>}
                    {i18n.language === "fr" ? "Pays" : "Country"} : <span className="thin">{user.hsProfile.country ? user.hsProfile.country : "France"}</span><br/><br/>
                    {user.hsProfile.nombre_de_personnes_dans_l_entreprise && <>{i18n.language === "fr" ? "Nombre de salariés" : "Number of employees"} : <span className="thin">{user.hsProfile.nombre_de_personnes_dans_l_entreprise}</span><br/><br/></>}
                    {user.hsProfile.chiffre_d_affaire_de_l_entreprise && <>{i18n.language === "fr" ? "Chiffre d'affaire" : "Turnover"} : <span className="thin">{user.hsProfile.chiffre_d_affaire_de_l_entreprise}</span><br/><br/></>}
                    {user.hsProfile.date_de_creation_de_l_entreprise && <>{i18n.language === "fr" ? "Année de création de l'entreprise" : "Company start year"} : <span className="thin">{user.hsProfile.date_de_creation_de_l_entreprise}</span><br/><br/></>}
                    {user.hsProfile.positionnement && <>{i18n.language === "fr" ? "Positionnement" : "Positioning"} : <span className='thin'>{user.hsProfile.positionnement?.split(';').join(', ')}</span><br/><br/></>}
                    {user.hsProfile.clientele && <>{i18n.language === "fr" ? "Clientèle" : "Customer base"} : <span className='thin'>{user.hsProfile.clientele?.split(';').join(', ')}</span><br/><br/></>}
                    {user.hsProfile.website && <>{i18n.language === "fr" ? "Site internet" : "Website"} : <a href={user.hsProfile.website} target="_blank" className='thin'>{user.hsProfile.website}</a><br/><br/></>}
                    {user.hsProfile.facebook && <>Facebook : <a href={user.hsProfile.facebook} target="_blank" className='thin'>{user.hsProfile.facebook}</a><br/><br/></>}
                    {user.hsProfile.instagram_account && <>Instagram : <a href={user.hsProfile.instagram_account} target="_blank" className='thin'>{user.hsProfile.instagram_account}</a><br/><br/></>}
                    {user.hsProfile.twitterhandle && <>Twitter : <a href={user.hsProfile.twitterhandle} target="_blank" className='thin'>{user.hsProfile.twitterhandle}</a><br/><br/></>}
                    {user.hsProfile.lien_linkedin && <>Linkedin : <a href={user.hsProfile.lien_linkedin} target="_blank" className='thin'>{user.hsProfile.lien_linkedin}</a><br/><br/></>}
                    {user.hsProfile.pinterest && <>Pinterest : <a href={user.hsProfile.pinterest} target="_blank" className='thin'>{user.hsProfile.pinterest}</a><br/><br/></>}
                    {user.user.portrait && <>
                        {i18n.language === "fr" ? "Portrait du ou des créateurs" : "Profile of the designer(s)"} : <br/><br/>
                        <img alt="" src={process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + user.user.portrait}/><br/><br/>
                        {i18n.language === "fr" ? "Crédit photo" : "Photo credit"} : <span className="thin">{user.hsProfile.credit_photo_et_legende}</span><br/><br/>
                    </>}
                    {user.user.logo && <>
                        {i18n.language === "fr" ? "Logo de l'entreprise" : "Company logo"} : <br/><br/>
                        <img alt="" src={process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + user.user.logo}/><br/><br/>
                    </>}
                </div>
            }
        </div>
    );
};

export default FDFicheEntreprise;